"use client"

import TextInputField from "../TextInputField/TextInputField"
import styles from "../../../styles/finder/finder.module.scss"
import CheckBox from "../checkbox/checkbox"
import { useUserStore } from "./store/finder_store"
import StyledText from "../../typography/typography-component"
import skColors from "../../../styles/skColors"
import { ReactNode } from "react"
import { useTranslations } from "next-intl"

type ContactFormProps = {
  withAddress?: boolean
  children?: ReactNode
}

const ContactForm = ({ children }: ContactFormProps) => {
  const t = useTranslations("index.finder")

  const {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    mail,
    setMail,
    phone,
    setPhone,
    plz,
    setPLZ,
    confirmDataUsage,
    setConfirmDataUsage,
  } = useUserStore()

  return (
    <>
      <div className={styles.contactFormWrapper}>
        <form className={styles.contactForm}>
          {/* FIRST NAME */}
          <div className={styles.fieldGroup}>
            <StyledText htmlFor="firstName" variant="pRegular" color={skColors.darkgreen[500]}>
              {t("contactForm.firstNameLabel")}:
            </StyledText>

            <TextInputField
              id="firstName"
              value={firstName ?? ""}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder={t("contactForm.firstNamePlaceholder")}
              style={undefined}
            />
          </div>

          {/* LAST NAME */}
          <div className={styles.fieldGroup}>
            <StyledText htmlFor="lastName" variant="pRegular" color={skColors.darkgreen[500]}>
              {t("contactForm.lastNameLabel")}:
            </StyledText>

            <TextInputField
              id="lastName"
              value={lastName ?? ""}
              onChange={(e) => setLastName(e.target.value)}
              placeholder={t("contactForm.lastNamePlaceholder")}
              style={undefined}
            />
          </div>

          {/* EMAIL */}
          <div className={styles.fieldGroup}>
            <StyledText variant="pRegular" color={skColors.darkgreen[500]}>
              {t("contactForm.emailLabel")}:
            </StyledText>

            <TextInputField
              value={mail ?? ""}
              onChange={(e) => setMail(e.target.value)}
              placeholder={t("contactForm.emailPlaceholder")}
              style={undefined}
            />
          </div>

          {/* PHONE */}
          <div className={styles.fieldGroup}>
            <StyledText variant="pRegular" color={skColors.darkgreen[500]}>
              {t("contactForm.phoneLabel")}:
            </StyledText>

            <TextInputField
              value={phone ?? ""}
              inputMode="numeric"
              pattern="[0-9]*"
              onChange={(e) => setPhone(e.target.value)}
              placeholder={t("contactForm.phonePlaceholder")}
              style={undefined}
            />
          </div>

          {/* PLZ / WOHNORT */}
          <div className={styles.fieldGroup}>
            <StyledText variant="pRegular" color={skColors.darkgreen[500]}>
              {t("step2a.plzLabel")}
            </StyledText>

            <TextInputField
              value={plz ?? ""}
              maxLength={5}
              inputMode="numeric"
              pattern="[0-9]*"
              onChange={(e) => {
                const val = e.target.value
                if (/^\d*$/.test(val)) setPLZ(val)
              }}
              placeholder={t("step2a.plzPlaceholder")}
              style={undefined}
            />
          </div>

          {children}
        </form>
      </div>

      {/* CHECKBOX */}
      <div className={styles.checkboxSection}>
        <div
          style={{
            display: "flex",
            maxWidth: "716px",
            //marginBottom: "48px",
            //padding: "8px",
            //gap: "16px",
          }}
        >
          <CheckBox
            checked={confirmDataUsage}
            onChange={() => setConfirmDataUsage(!confirmDataUsage)}
            id="confirmDataUsage"
          />

          <StyledText as="label" htmlFor="confirmDataUsage" variant="pRegular">
            {t("contactForm.confirmDataUsage")}
          </StyledText>
        </div>
      </div>
    </>
  )
}

export default ContactForm
